import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="5" width="22" height="22" rx="11" stroke="#F83D44" strokeWidth="2" />
      <path
        d="M20.2929 13.1357C20.6834 12.7452 20.6834 12.112 20.2929 11.7215L20.2785 11.7071C19.888 11.3166 19.2548 11.3166 18.8643 11.7071L17.4142 13.1572C16.6332 13.9383 15.3668 13.9383 14.5858 13.1572L13.1357 11.7071C12.7452 11.3166 12.112 11.3166 11.7215 11.7071L11.7071 11.7215C11.3166 12.112 11.3166 12.7452 11.7071 13.1357L13.1572 14.5858C13.9383 15.3668 13.9383 16.6332 13.1572 17.4142L11.7071 18.8643C11.3166 19.2548 11.3166 19.888 11.7071 20.2785L11.7215 20.2929C12.112 20.6834 12.7452 20.6834 13.1357 20.2929L14.5858 18.8428C15.3668 18.0617 16.6332 18.0617 17.4142 18.8428L18.8643 20.2929C19.2548 20.6834 19.888 20.6834 20.2785 20.2929L20.2929 20.2785C20.6834 19.888 20.6834 19.2548 20.2929 18.8643L18.8428 17.4142C18.0617 16.6332 18.0617 15.3668 18.8428 14.5858L20.2929 13.1357Z"
        fill="#F83D44"
      />
    </svg>
  );
};

export default Svg;
